import type { FaireProductEntity } from "../../entity_types/product";

export const p_rkt6sz2etj: FaireProductEntity = {
  token: "p_rkt6sz2etj",
  type: "product",
  name: "Raspberry Rhinestone Tutu Skirt - Kids Clothing",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/a5bd34873de617e76d03fbc240cbcee61f4505873db031bce5933c3609e04321.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0463647d4bbda1bb2e1d0a0f8af534332cbdfc4f916fa2bbccda42eb3d79b174.jpeg",
    "https://cdn.faire.com/fastly/2aa7b2c02b9b50b450a0012c55e166a89a9e73cdc1ace0e8e469cb1670c056fa.jpeg",
    "https://cdn.faire.com/fastly/2c6693b10514f53e259154aa43bf6d9af62bb83dc7c39952e945513171da6a55.jpeg",
    "https://cdn.faire.com/fastly/c1e7c81c4fc6027333e5f202b3d34002b18034278b95458ede7ae88432439ce0.jpeg",
    "https://cdn.faire.com/fastly/307f24fc57488516afa2b6b0d2033b733d4f6b7f38bbeb5e65a4c786b5100873.jpeg",
  ],
  priceDollars: 20,
  description:
    "Let your little star twirl through her big day in this vibrant pink tutu skirt, scattered with multi-colored rhinestones for a magical touch of sparkle.\n\nFeatures:\n*Raspberry pink tulle accented with multi-colored rhinestones\n*Pink cotton lining\n*Pink elastic waistband\n*Care: Hand wash and line dry\n\nThe Sweet Wink difference:\n*Super soft tulle that doesn’t scratch or itch\n*Cotton lining provides extra coverage and comfort",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:19.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
